import React from 'react';
import PropTypes from 'prop-types';
import {
  Modal, Button, Row, Col, Avatar, Tag
} from 'antd';
 
import styles from './ViewUser.module.less';
import Icon from '@ant-design/icons';
import { useTranslation } from 'react-i18next';

import { ReactComponent as companyIcon } from '@assets/svg/company.svg';
import { ReactComponent as energyIcon } from '@assets/svg/energy.svg';
import { ReactComponent as loadingIcon } from '@assets/svg/loading.svg';

const imagePath = 'https://upload.wikimedia.org/wikipedia/commons/thumb/5/59/User-avatar.svg/2048px-User-avatar.svg.png';

function ViewUser({
  isModalVisible,
  setIsModalVisible,
  resetPassword,
  loadingResetPassword,
  modalData,
}) {
  const { t } = useTranslation(); 
  
  return (
    <Modal  
      centered
      visible={isModalVisible}
      onCancel={() => setIsModalVisible(false)}
      closable={false} 
      footer={[
        <Button key="back" icon={<Icon component={loadingIcon} />} onClick={() => resetPassword()} loading={loadingResetPassword}>
          <span className={styles.textInfo}>{t('common.reset_password')}</span>
        </Button>,
        <Button key="button" type="primary" onClick={() => setIsModalVisible(false)} >
          {t('common.accept')}
        </Button>
      ]} 
    >
     <div>
      {/* Primera fila */}
      <Row gutter={16} align="middle">
        <Col span={4}>
          <Avatar 
          src={modalData.image??imagePath}
          style={{
            width: 64,
            height: 64,
            borderRadius: '50%',
            marginRight: 10,
            background: '#eae4e4',
          }} />
        </Col>
        <Col span={20}>
          <h2 style={{marginBottom:0}}>{modalData?.first_name} {modalData?.last_name}</h2>
          <span className={styles.spacingSubText}>{modalData.role}</span>
        </Col>
      </Row>

      {/* Segunda fila */}
      <Row gutter={16} style={{marginTop:25}}> 
        <Col xs={24} sm={24} md={12} lg={12} xl={12}>
          <p>
            <strong>
              <span className={styles.spacingText}>•</span>
              {' '}{t('tables.users.columns.mail')}
            </strong>
            <br></br>            
            <span className={styles.spacingSubText}>
            {modalData?.email}
            </span>
          </p>
        </Col>
        <Col xs={24} sm={24} md={12} lg={12} xl={12}> 
          <p>
            <strong>
              <span className={styles.spacingText}>•</span>
              {' '}{t('tables.users.columns.phone')}
            </strong>
            <br></br>
            <span className={styles.spacingSubText}>
            {modalData?.phone}
            </span>
          </p>
        </Col>
        <Col xs={24} sm={24} md={12} lg={12} xl={12}>
          <p>
            <strong>
              <span className={styles.spacingText}>•</span>
              {' '}{t('tables.users.columns.date')}
            </strong>
            <br></br>
            <span className={styles.spacingSubText}>
              {modalData.birthdate}
            </span>
          </p> 
        </Col>
      </Row>

      {/* Tercera fila */}

      {
        modalData.role !== 'Visitor' &&
          <Row gutter={16} style={{marginTop:10}}> 
            <Col xs={24} sm={24} md={24} lg={24} xl={24}>
              {modalData?.business_types?.length>0 && 
                <p>
                  <strong>
                    <span className={styles.spacingText}>•</span>
                    {' '}{t('tables.users.columns.access')}
                  </strong>
                </p>
              } 
            </Col>
            <Col>
              {
                modalData?.business_types?.map((item)=>{
                return <>
                    <Tag key={item.id} icon={ <Icon component={item.type=='Comunidades'?companyIcon:energyIcon} />} color="default" 
                      className={styles.tagMargin}> 
                      <span className={styles.textTag}>{item.name}</span>
                    </Tag>
                </>
                })
              } 
            </Col> 
        </Row>
      }

      {
        modalData.role === 'Visitor' &&
          <Row gutter={16} style={{marginTop:10}}> 
            <Col xs={24} sm={24} md={24} lg={24} xl={24}>
              <p>
                <strong>
                  <span className={styles.spacingText}>•</span>
                  {' '}{t('tables.users.columns.access')}
                </strong>
              </p>
            </Col>
            <Col>
              <Tag
                icon={<Icon component={modalData?.business_types[0]?.type === 'Comunidades' ? companyIcon : energyIcon} style={{ fontSize: 16 }} />}
                color="default"
                className={styles.tagMargin}
              >
                <span className={styles.textTag}>{modalData?.business_types[0]?.name}</span><br /> 

                {modalData?.business_types[0]?.type === 'Comunidades' ? 
                <span className={styles.textTag2}>• {t('forms.users.labels.clients')}: {modalData?.clients_id[0]?.celsia_id}</span> : 
                <span className={styles.textTag2}>• {t('forms.users.labels.devices')}: {modalData?.devices_id[0]?.name}</span>}
              </Tag>
            </Col> 
        </Row>
      }
     
    </div>
 
    </Modal>
  );

}
ViewUser.propTypes = {
  isModalVisible: PropTypes.bool,
  setIsModalVisible: PropTypes.func.isRequired,
  modalData: PropTypes.object,
};

ViewUser.defaultProps = {
  isModalVisible: false,
  modalData: {},
};

export default ViewUser;
